module.exports = paginationCard = {

  getDivisionLatLng: (pageConfig) ->
    return pageConfig.ell if pageConfig.ell
    return "#{pageConfig.currentDivision.lat},#{pageConfig.currentDivision.lng}" if pageConfig.currentDivision.lat
    return null

  loadButtonAttributes: (loadMoreBtn, pageConfig) ->
    dealType: loadMoreBtn.attr("data-deal-type")
    isCategoryFallback: loadMoreBtn.attr("data-is-category-fallback")
    categoryFallback: loadMoreBtn.attr("data-category-fallback")
    context: loadMoreBtn.attr("data-context")
    division: loadMoreBtn.attr("data-division")
    noHero: loadMoreBtn.attr("data-nohero") or false
    filterQuery: loadMoreBtn.attr("data-filter-query")
    pageType: loadMoreBtn.attr("data-page-type")
    latLng: loadMoreBtn.attr("data-division-loc") or @getDivisionLatLng(pageConfig)
    includeHtml: pageConfig.newRender or false
    unsafe: loadMoreBtn.attr("data-unsafe-deals")
    showOptions: loadMoreBtn.attr("data-show-options") or "false"
    includeQuery: loadMoreBtn.attr("data-inclue-query") or false

  copyDataAttributes: ($source, $destination) ->
    for i in $source[0].attributes
      if i.nodeName.indexOf('data-') == 0
        $destination.attr(i.nodeName, $source.attr(i.nodeName))

}
